
import { ArrowPosition, Wrapper } from './styles';

export default {
  name: 'Tooltip',
  components: {
    Wrapper,
  },
  props: {
    arrowPos: {
      type: String,
      default: 'topRight',
      validator(value: typeof ArrowPosition[number]) {
        return ArrowPosition.indexOf(value) !== -1;
      },
    },
    maxWidth: {
      type: Number,
      default: 216,
    },
    text: {
      type: String,
      default: 'Sit vitae ultrices felis.',
    },
  },
};
